import { WithAuthorization } from "../../../../context";
import { Page } from "../../../../components/Page";
import { useTranslation } from "react-i18next";
import { Card } from "../../../../components/Card";
import { Center, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useState } from "react";
import { CarbonPriceDescription, CarbonPriceTracker } from "./components";

function CarbonPrice() {
  const { t } = useTranslation("translation", {
    keyPrefix: "carbonPrice"
  });
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} overflow="auto">
          <Center>
            <TabList borderBottom="none" overflow="auto">
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.description")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.tracker")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <CarbonPriceDescription />
            </TabPanel>
            <TabPanel padding="0">
              <CarbonPriceTracker />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(CarbonPrice);